"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = void 0;
exports.ContainerComponent = ContainerComponent;
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const DataUpload = __importStar(require("@genesys/client-core/lib/data-upload"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const Exporter = __importStar(require("@genesys/client-core/lib/exporter"));
const GenesysPropertiesSelector = __importStar(require("@genesys/client-core/lib/genesys-properties-selector"));
const GenesysPropertiesSelectorRenderers = __importStar(require("@genesys/client-core/lib/genesys-properties-selector-renderers"));
const property_1 = require("@genesys/property");
const LanguageTexts = __importStar(require("@genesys/shared/lib/language-texts"));
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Actions = __importStar(require("./actions"));
const calculate_component_1 = require("./calculate-component");
const csv_file_handling_1 = require("./csv-file-handling");
const groupNames = __importStar(require("./group-names"));
const property_definitions_1 = require("./property-definitions");
const ResultScreenSelector = __importStar(require("./result-screen-selector"));
exports.Root = styled_components_1.default.div `
  display: flex;
  position: relative;
  flex-wrap: wrap;
  padding: 24px;
`;
function ContainerComponent(props) {
    const properties = (0, property_definitions_1.getProperties)(props.input, props.fanCurvePoints.length);
    const onAirInChange = (pvs) => props.dispatch(Actions.setPropertiesInput(pvs));
    const onCalculate = createOnCalculate(props);
    const onImportFile = (res) => props.dispatch(Actions.setPropertiesFromFile((0, csv_file_handling_1.parseFile)(res)));
    const curvePointsGroups = props.fanCurvePoints.map((_p, ix) => "point" + (ix + 1));
    const addPoint = () => props.dispatch(Actions.addFanCurvePoint());
    const deletePoint = () => props.dispatch(Actions.deleteFanCurvePoint());
    const selectedProperties = property_1.PropertyValueSet.merge(flattenCurvePointsToPvs(props.fanCurvePoints), props.input);
    const PointsDisplayer = styled_components_1.default.div `
    margin-left: 5px;
    margin-right: 5px;
  `;
    const translation = {
        propertyName: (propertyName, translate) => {
            const regex = new RegExp(/^point([0-9]*)/);
            const pointStr = propertyName.replace(regex, "");
            return translate(LanguageTexts.dynamicText(pointStr));
        }
    };
    return (React.createElement(Contexts.clientConfigContext.Consumer, null, (config) => (React.createElement(exports.Root, null,
        React.createElement(calculate_component_1.CalculateComponent, { authorization: config.authorization, graphqlEndpoint: config.graphqlEndpoint, state: props, onParseResults: (result) => props.dispatch(Actions.parseResult(result)) }),
        React.createElement(Elements.FlexContainerRowWithPadding, { center: false },
            React.createElement(Elements.FlexContainerStack, { center: false },
                React.createElement(Elements.FlexContainerRow, { center: true },
                    React.createElement(Elements.StandardButtonSmall, { onClick: deletePoint }, "-"),
                    React.createElement(Elements.FlexContainerStack, { centerVertically: true },
                        React.createElement(PointsDisplayer, null, "Curve points: " + props.fanCurvePoints.length)),
                    React.createElement(Elements.StandardButtonSmall, { onClick: addPoint }, "+")),
                React.createElement(Elements.FlexContainerStack, null,
                    React.createElement(Elements.InnerContainer, null,
                        React.createElement(Elements.H3, null, "Air In"),
                        React.createElement(GenesysPropertiesSelector.PropertiesSelectorContainer, { selectedProperties: selectedProperties, productProperties: properties.properties, readOnlyProperties: ["actualdensity"], screenAmountProfileFieldGroup: "FanProTool", onChange: (pvs) => onAirInChange(pvs), customTranslation: translation, uniqueId: "fanpro_airin", layoutRenderer: GenesysPropertiesSelectorRenderers.columnsStackedWithGroupsLayoutRenderer, sections: {
                                "section-1": {
                                    groups: [
                                        groupNames.fanControlMode,
                                        groupNames.fanQuantity,
                                        groupNames.fanDefinition,
                                        groupNames.fanPerformanceMmodel,
                                        groupNames.motorDefinition,
                                        groupNames.fanOperationalRange,
                                        groupNames.target,
                                        groupNames.airInput
                                    ]
                                },
                                "section-2": { groups: curvePointsGroups }
                            } })),
                    React.createElement(Elements.InnerContainer, null,
                        React.createElement(Elements.StandardButton, { onClick: () => onCalculate() }, "Calculate fan"))),
                React.createElement(Elements.FlexContainerStack, null,
                    React.createElement(DataUpload.SimpleDataUploadContainer, { onParsed: (res) => onImportFile(res) }, (onClick) => (React.createElement(Elements.StandardButton, { onClick: onClick }, "Import")))),
                " ",
                React.createElement(Exporter.XlsxSingleSheetExport, { data: (0, csv_file_handling_1.inputsToFile)(props.input, props.fanCurvePoints), filename: "FanPro_inputs" }, (onClick) => (React.createElement(Elements.StandardButton, { onClick: () => onClick() }, "Download"))),
                React.createElement(Elements.FlexContainerRowWithPadding, { center: false },
                    React.createElement(ResultScreenSelector.SelectScreen, { pvses: [props.input], fanCurvePoints: props.fanCurvePoints, hasResults: props.results !== undefined }))))))));
}
function createOnCalculate(props) {
    return () => props.dispatch(Actions.calculateFan("FanPerformanceResult"));
}
function flattenCurvePointsToPvs(fanCurvePoints) {
    return fanCurvePoints.reduce((a, b, ix) => property_1.PropertyValueSet.merge(fanCurvePointToPvs(b, ix + 1), a), property_1.PropertyValueSet.Empty);
}
function fanCurvePointToPvs(point, pointNumber) {
    return property_1.PropertyValueSet.map((kvp) => ({
        key: "point" + pointNumber + kvp.key,
        value: kvp.value
    }), point);
}
//# sourceMappingURL=container-component.js.map